<template>
    <div>
        <div
            id="content"
            class="content animated slideInRight delay-1s"
        >
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-header">
                            <div class="card-title">
                                Cadastrar Veículos
                                <span class="required_fields text-white">
                                    <span class="required">*</span>
                                    Campos obrigatórios
                                </span>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="section-form">
                                <div class="row">
                                    <div class="col-md-9">
                                        <form id="form">
                                            <div class="row">
                                                <div class="col-md-4">
                                                    <div class="form-group">
                                                        <label for="brand">
                                                            <span class="required">*</span>
                                                            Marca:
                                                        </label>
                                                        <input
                                                            type="text"
                                                            class="form-control"
                                                            v-model="vehicle.brand"
                                                        />
                                                    </div>
                                                </div>
                                                <div class="col-md-4">
                                                    <div class="form-group">
                                                        <label for="model">
                                                            <span class="required">*</span>
                                                            Modelo:
                                                        </label>
                                                        <input
                                                            type="text"
                                                            class="form-control"
                                                            v-model="vehicle.model"
                                                        />
                                                    </div>
                                                </div>
                                                <div class="col-md-4">
                                                    <div class="form-group">
                                                        <label for="color">
                                                            <span class="required">*</span>
                                                            Cor
                                                        </label>
                                                        <v-select
                                                            :options="colors"
                                                            label="description"
                                                            :reduce="(colors) => colors.description"
                                                            class="style-chooser"
                                                            v-model="vehicle.color"
                                                        >
                                                            <div slot="no-options">Carregando...</div>
                                                        </v-select>
                                                    </div>
                                                </div>
                                                <div class="col-md-2">
                                                    <div class="form-group">
                                                        <label for="board">
                                                            <span class="required">*</span>
                                                            Placa:
                                                        </label>
                                                        <input
                                                            style="text-transform: uppercase"
                                                            type="text"
                                                            class="form-control"
                                                            v-mask="'AAA#X##'"
                                                            v-model="vehicle.board"
                                                        />
                                                    </div>
                                                </div>

                                                <div class="col-md-2">
                                                    <div class="form-group">
                                                        <label for="board">
                                                            <span class="required">*</span>
                                                            Lugares:
                                                        </label>
                                                        <input
                                                            style="text-transform: uppercase"
                                                            type="number"
                                                            min="1"
                                                            max="5"
                                                            class="form-control"
                                                            v-model="vehicle.places"
                                                        />
                                                    </div>
                                                </div>

                                                <div class="col-md-4">
                                                    <div class="form-group">
                                                        <label for="type">
                                                            <span class="required">*</span>
                                                            Tipo:
                                                        </label>
                                                        <select
                                                            v-model="vehicle.vehicle_type_id"
                                                            class="form-control"
                                                        >
                                                            <option
                                                                v-for="type in types"
                                                                :value="type.id"
                                                                :key="type.id"
                                                            >
                                                                {{ type.description }}
                                                            </option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div class="col-md-4">
                                                    <div class="form-group">
                                                        <label for="combustible">
                                                            <span class="required">*</span>
                                                            Combustível:
                                                        </label>
                                                        <select
                                                            v-model="vehicle.combustible"
                                                            class="form-control"
                                                            id="combustible"
                                                            name="combustible"
                                                            tabindex="5"
                                                        >
                                                            <option value="Etanol">Etanol</option>
                                                            <option value="Gasolina">Gasolina</option>
                                                            <option value="Flex">Flex</option>
                                                            <option value="GNV">GNV</option>
                                                            <option value="Diesel">Diesel</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="car-img">
                                            <img
                                                v-if="previewImage"
                                                :src="previewImage"
                                                class="uploading-image car"
                                                alt="Imagem do Veículo"
                                            />
                                            <img
                                                v-else
                                                :src="vehicle.photo"
                                                class="car"
                                                alt="Imagem do Veículo"
                                            />
                                            <qrcode-vue
                                                v-if="vehicle.board"
                                                class="code"
                                                :value="vehicle.board"
                                                level="H"
                                            ></qrcode-vue>
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="form-group">
                                            <label for="renavam_code">Código Renavam:</label>
                                            <input
                                                type="text"
                                                class="form-control"
                                                v-mask="'###########'"
                                                v-model="vehicle.renavam_code"
                                            />
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="form-group">
                                            <label for="chassi">Chassi:</label>
                                            <input
                                                type="text"
                                                class="form-control"
                                                maxlength="17"
                                                v-model="vehicle.chassi"
                                            />
                                        </div>
                                    </div>
                                    <div class="col-md-2">
                                        <div class="form-group">
                                            <label for="year_of_manufacture">
                                                <span class="required">*</span>
                                                Ano de Fab:
                                            </label>
                                            <input
                                                type="text"
                                                v-mask="'####'"
                                                class="form-control"
                                                v-model="vehicle.year_of_manufacture"
                                            />
                                        </div>
                                    </div>
                                    <div class="col-md-2">
                                        <div class="form-group">
                                            <label for="model_year">
                                                <span class="required">*</span>
                                                Ano Mod:
                                            </label>
                                            <input
                                                type="text"
                                                v-mask="'####'"
                                                class="form-control"
                                                v-model="vehicle.model_year"
                                            />
                                        </div>
                                    </div>
                                    <div class="col-md-2">
                                        <div class="form-group">
                                            <label for="current_km">
                                                <span class="required">*</span>
                                                KM Atual:
                                            </label>
                                            <the-mask
                                                class="form-control"
                                                v-model="vehicle.current_km"
                                                :mask="['####', '#.###', '##.###', '###.###']"
                                            />
                                        </div>
                                    </div>

                                    <div class="col-md-3">
                                        <div class="form-group">
                                            <label for="branch_id">
                                                <span class="required">*</span>
                                                Filial:
                                            </label>
                                            <v-select
                                                :options="branches"
                                                label="description"
                                                :reduce="(branch) => branch.id"
                                                class="style-chooser"
                                                v-model="vehicle.branch_id"
                                            >
                                                <div slot="no-options">Nenhuma filial encontrada</div>
                                            </v-select>
                                        </div>
                                    </div>

                                    <div class="col-md-3">
                                        <div class="form-group">
                                            <label for="color">
                                                Centro de Custo:
                                            </label>
                                            <v-select
                                                :options="cost_centers"
                                                label="description"
                                                :reduce="(cost_center) => cost_center.id"
                                                class="style-chooser"
                                                v-model="vehicle.cost_center_id"
                                            >
                                                <div slot="no-options">Nenhum centro de custo encontrado</div>
                                            </v-select>
                                            <span
                                                class="text-muted"
                                                style="font-size: 12px"
                                            >
                                                Se o campo ficar em branco o veículo é compartilhado
                                            </span>
                                        </div>
                                    </div>

                                    <div class="col-md-2">
                                        <div class="form-group">
                                            <label for="erp_code">
                                                <span class="required">*</span>
                                                Código ERP:
                                            </label>
                                            <input
                                                type="text"
                                                class="form-control"
                                                v-model="vehicle.erp_code"
                                            />
                                        </div>
                                    </div>

                                    <div class="col-md-3">
                                        <div class="form-group">
                                            <label for="is_executive">
                                                Veículo Executivo:
                                            </label>
                                            <div class="custom-control custom-switch">
                                                <input
                                                    type="checkbox"
                                                    class="custom-control-input"
                                                    id="switch-is-executive"
                                                    v-model="vehicle.is_executive"
                                                />
                                                <label
                                                    class="custom-control-label"
                                                    for="switch-is-executive"
                                                >
                                                    <span class="ml-2">
                                                        Sim
                                                    </span>
                                                </label>
                                            </div>
                                            <span
                                                class="text-muted"
                                                style="font-size: 12px"
                                            >
                                                Apenas motoristas executivos podem usar este veículo
                                            </span>
                                        </div>
                                    </div>

                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="description">
                                                <span class="required">*</span>
                                                Descrição:
                                            </label>
                                            <textarea
                                                class="form-control"
                                                v-model="vehicle.description"
                                                maxlength="40"
                                                rows="3"
                                            ></textarea>
                                        </div>
                                    </div>


                                    <br/>
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label
                                                for="photo"
                                                id="pass"
                                            >Foto do Veículo
                                            </label>
                                            <br/>
                                            <input
                                                id="photo"
                                                type="file"
                                                class="form-control"
                                                name="photo"
                                                @change="uploadImage"
                                                accept="image/*"
                                                placeholder
                                            />
                                            <span
                                                class="text-muted"
                                                style="font-size: 12px"
                                            >
                                                Lembrando que são
                                                <b>150 pixels</b> de altura e <b>200 pixels</b> de lagura
                                                por padrão!
                                            </span>
                                        </div>
                                        <hr/>
                                        <div class="block text-right">
                                            <router-link
                                                to="/vehicles"
                                                class="btn btn-back"
                                            >
                                                <i class="fa fa-arrow-left mr-2"></i>
                                                Voltar
                                            </router-link>
                                            <a
                                                class="btn btn-add"
                                                @click="save"
                                            >
                                                Salvar
                                                <i class="fa fa-save ml-2"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Loading Overlay -->
        <loading
            :active.sync="isLoading"
            :is-full-page="fullPage"
        ></loading>
    </div>
</template>

<script>
import BaseCrud from "../Base/BaseCrud";
import QrcodeVue from "qrcode.vue";
import vSelect from "vue-select";
import department from "../../router/department";
import {getMessage} from "../../composables/message";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
    data() {
        return {
            isLoading: true,
            fullPage: false,
            previewImage: null,
            vehicle: {
                description: "",
                board: "",
                branch_id: "",
                brand: "",
                color: "",
                model: "",
                year_of_manufacture: "",
                model_year: "",
                renavam_code: "",
                chassi: "",
                combustible: "",
                current_km: "",
                photo: "",
                vehicle_qr_code_photo: "",
                category_id: 1,
                vehicle_type_id: "",
                color_id: "",
                cost_center_id: "",
                places: "",
                is_executive: false,
            },
            checklist_item: {
                id: "",
                description: "",
                checked: "",
            },
            checklist_items: [],
            link_checklist_items: [],
            categories: [],
            casters: [],
            branches: [],
            types: [],
            checkeds: [],
            colors: [],
            cost_centers: [],
            departments: [],
        };
    },
    methods: {
        makeFormData: function () {
            const self = this;
            let fd = new FormData();

            let photo = document.getElementById("photo");
            let vehicleBoard = document.getElementById("vehicle_board");

            fd.append("description", self.vehicle.description);
            fd.append("board", self.vehicle.board);
            fd.append("branch_id", self.vehicle.branch_id);
            fd.append("brand", self.vehicle.brand);
            fd.append("color", self.vehicle.color);
            fd.append("model", self.vehicle.model);
            fd.append("year_of_manufacture", self.vehicle.year_of_manufacture);
            fd.append("model_year", self.vehicle.model_year);
            fd.append("vehicle_status_id", "1");

            fd.append("renavam_code", self.vehicle.renavam_code);
            fd.append("current_km", self.vehicle.current_km);

            fd.append("chassi", self.vehicle.chassi);
            fd.append("combustible", self.vehicle.combustible);

            var current_km = self.vehicle.current_km;

            if (photo.files[0]) {
                fd.append("photo", photo.files[0] ? photo.files[0] : "");
            }

            fd.append("category_id", self.vehicle.category_id);
            fd.append("vehicle_type_id", self.vehicle.vehicle_type_id);
            fd.append("places", self.vehicle.places);
            fd.append("erp_code", self.vehicle.erp_code);
            fd.append("is_executive", self.vehicle.is_executive ? 1 : 0);

            fd.append("cost_center_id", self.vehicle.cost_center_id ? (typeof self.vehicle.cost_center_id === 'object' ? self.vehicle.cost_center_id.id : self.vehicle.cost_center_id) : '');

            if (self.vehicle.id) {
                fd.append("id", self.vehicle.id);
                fd.append("_method", "PUT");
            }

            return fd;
        },
        save: function () {
            const self = this;
            let api = self.$store.state.api + "vehicles";

            let fd = self.makeFormData();

            if (self.vehicle.id) {
                api += "/" + self.vehicle.id;
            }

            self.$http
                .post(api, fd)
                .then((response) => {
                    self.$message(
                        "Sucesso",
                        `Informações guardadas com sucesso`,
                        "success"
                    );
                    this.$router.push("/vehicles");
                })
                .catch((error) => {
                    const message = error.response.data.errors ? getMessage(error.response.data.errors) : error.response.data
                    self.$message(null, message, "error");
                });
        },
        uploadImage(e) {
            const image = e.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(image);
            reader.onload = (e) => {
                this.previewImage = e.target.result;
            };
        },
        getVehicle: function (id) {
            const self = this;
            const api = self.$store.state.api + "vehicles/" + id;

            self.$http
                .get(api)
                .then((response) => {
                    self.vehicle = response.data.data[0];

                    this.vehicle.cost_center_id = this.cost_centers.find(
                        (center) => center.id === this.vehicle.cost_center_id
                    ) || null;

                    this.vehicle.department_id = this.departments.find(
                        (department) => department.id === this.vehicle.department_id
                    ) || null;
                })
                .catch((error) => {
                    const message = error.response.data.errors ? getMessage(error.response.data.errors) : error.response.data
                    self.$message(null, message, "error");
                });
        },
        getCategories: function (id) {
            const self = this;
            const api = self.$store.state.api + "categories/?paginated=false";

            return self.$http
                .get(api)
                .then((response) => {
                    self.categories = response.data.data;
                })
                .catch((error) => {
                    const message = error.response.data.errors ? getMessage(error.response.data.errors) : error.response.data
                    self.$message(null, message, "error");
                });
        },
        getCasters: function (id) {
            const self = this;
            const api = self.$store.state.api + "vehicleCasters/";

            return self.$http
                .get(api)
                .then((response) => {
                    self.casters = response.data.data;
                })
                .catch((error) => {
                    const message = error.response.data.errors ? getMessage(error.response.data.errors) : error.response.data
                    self.$message(null, message, "error");
                });
        },
        getBranches: function (id) {
            const self = this;
            const api = self.$store.state.api + "branches/?paginated=false";

            return self.$http
                .get(api)
                .then((response) => {
                    self.branches = response.data.data;
                })
                .catch((error) => {
                    const message = error.response.data.errors ? getMessage(error.response.data.errors) : error.response.data
                    self.$message(null, message, "error");
                });
        },
        getTypes: function (id) {
            const self = this;
            const api = self.$store.state.api + "vehicleTypes/";

            return self.$http
                .get(api)
                .then((response) => {
                    self.types = response.data.data;
                })
                .catch((error) => {
                    const message = error.response.data.errors ? getMessage(error.response.data.errors) : error.response.data
                    self.$message(null, message, "error");
                });
        },
        getChecklistItems: function (id) {
            const self = this;
            const api = self.$store.state.api + "checklistItems/?paginated=false";

            return self.$http
                .get(api)
                .then((response) => {
                    self.checklist_items = response.data.data;
                })
                .catch((error) => {
                    const message = error.response.data.errors ? getMessage(error.response.data.errors) : error.response.data
                    self.$message(null, message, "error");
                });
        },
        getColors: function (id) {
            const self = this;
            const api = self.$store.state.api + "colors/";

            return self.$http
                .get(api)
                .then((response) => {
                    self.colors = response.data.data;
                })
                .catch((error) => {
                    const message = error.response.data.errors ? getMessage(error.response.data.errors) : error.response.data
                    self.$message(null, message, "error");
                });
        },
        fetch(url) {
            const self = this;
            const api = self.$store.state.api + url + '?paginated=false';

            return self.$http
                .get(api)
                .then((response) => {
                    return response.data.data;
                })
                .catch((error) => {
                    const message = error.response.data.errors ? getMessage(error.response.data.errors) : error.response.data
                    self.$message(null, message, "error");
                    return [];
                });
        },
        getDatas() {
            const self = this;
            return Promise.all([
                self.fetch('cost-centers'),
            ]).then(([costCenters]) => {
                self.cost_centers = costCenters;
            }).catch((error) => {
                console.error("Erro ao buscar dados:", error);
            });
        }
    },
    mounted: function () {
        const self = this;

        // Carrega os dados básicos primeiro
        Promise.all([
            self.getDatas(),
            self.getCategories(),
            self.getCasters(),
            self.getBranches(),
            self.getTypes(),
            self.getChecklistItems(),
            self.getColors()
        ]).then(() => {
            // Só busca o veículo após todos os dados auxiliares estarem carregados
            let id = self.$route.params.id;
            if (id) {
                self.getVehicle(id);
            }
            // Remove o loading após carregar todos os dados
            self.isLoading = false;
        }).catch((error) => {
            console.error("Erro ao carregar dados auxiliares:", error);
            setTimeout(() => {
                self.isLoading = false;
            }, 300)
        });
    },
    components: {
        BaseCrud,
        QrcodeVue,
        vSelect,
        Loading,
    },
};
</script>
<style scoped>
#most {
    display: none;
}

#pass:hover #most {
    display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/Vehicle/Add.vue